import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box } from "@mui/material"
import Tooltip from '@mui/material/Tooltip';
import { IDocListItem } from "../../models/IDocListResponse"
import { useEffect, useState } from "react";

const SelectToPrintModal =
    (props: {
        selectDocsModalOpen: boolean,
        openRefreshConfirm: any,
        handleClose: any
        documentList: Array<IDocListItem>
        selectedDocumentList: Array<IDocListItem>
        setSelectedDocumentList: any
    }) => {

        const [selectedDocs, setSelectedDocs] = useState<Array<IDocListItem>>([]);

        useEffect(() => {
            setSelectedDocs([...props.selectedDocumentList]);
        }, [props.selectedDocumentList]);

        const selectDocToggle = (doc: IDocListItem) => {
            const cIdx = selectedDocs.indexOf(doc);
            const newDocs = [...selectedDocs];
            if (cIdx === -1)
                newDocs.push(doc);
            else
                newDocs.splice(cIdx, 1);

            setSelectedDocs(newDocs);
        }

        const handleToggleSelection = () => {
            const newDocs = props.documentList.filter((doc) => !selectedDocs.includes(doc));
            setSelectedDocs(newDocs);
        }

        const handleSelectAll = () => {
            const newDocs = selectedDocs.length === props.documentList.length ? [] : [...props.documentList];
            setSelectedDocs(newDocs);
        }

        const handleOk = () => {
            props.setSelectedDocumentList(selectedDocs);
            props.handleClose(false)
        }

        return (
            <Dialog open={props.selectDocsModalOpen} onClose={props.handleClose}>
                <DialogTitle>
                    Select Documents ({selectedDocs.length}/{props.documentList.length})
                </DialogTitle>
                <DialogContent>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <Tooltip title="Select All" placement="top">
                                    <Checkbox
                                        edge="start"
                                        checked={selectedDocs.length === props.documentList.length}
                                        tabIndex={-1}
                                        onClick={handleSelectAll}
                                    />
                                </Tooltip>
                            </ListItemIcon>
                            <ListItemText
                                primary="Document Name"
                                primaryTypographyProps={{ fontWeight: 'bold' }}
                                sx={{ textAlign: 'center', width: '100%' }}
                            />
                        </ListItem>
                        {props.documentList.map((doc) => {
                            return (
                                <ListItem key={doc.documentIndex} disablePadding>
                                    <ListItemButton role={undefined} onClick={() => { selectDocToggle(doc) }} dense>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                checked={selectedDocs.includes(doc)}
                                                tabIndex={-1}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={`Label-Doc-${doc.documentIndex}`} primary={doc.name}></ListItemText>
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Box sx={{ flexGrow: 1 }}>
                        <Button variant="contained" size="small" color="success" onClick={handleToggleSelection}>
                            Toggle Selection
                        </Button>
                    </Box>
                    <Button variant="contained" size="small" onClick={handleOk}>Ok</Button>
                </DialogActions>
            </Dialog>
        )

    }

export default SelectToPrintModal;